import { useEffect, useState } from 'react';

/**
 * Attach `ref` to an element. `isIntersecting` is true while at least `threshold` of it is visible,
 * as in usehooks-ts — an element that can never reach the threshold never counts as intersecting.
 */
export function useIntersectionObserver({ threshold = 0 }: { threshold?: number } = {}): {
  ref: (node: Element | null) => void;
  isIntersecting: boolean;
} {
  const [element, setElement] = useState<Element | null>(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (element == null) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsIntersecting(entry.isIntersecting && entry.intersectionRatio >= threshold),
      { threshold },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, threshold]);

  return { ref: setElement, isIntersecting };
}
